var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-padding-gray" }, [
    _c("h2", { staticClass: "text-center" }, [
      _vm._v(_vm._s(_vm.$t("message.home.customer_reviews")))
    ]),
    _vm._v(" "),
    _c(
      "h2",
      { staticClass: "text-center", staticStyle: { color: "#00ABC2" } },
      [_vm._v(_vm._s(_vm.$t("message.home.professional_service")))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 text-right" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: { to: "/reviews", tag: "a" }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("message.see_all")) + " "
                ),
                _c("i", { staticClass: "far fa-angle-right" })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "owl-carousel owl-theme homepage" },
            _vm._l(_vm.reviews, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "item" },
                [_c("review-items", { attrs: { item: item } })],
                1
              )
            }),
            0
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-735fe551", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-735fe551","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/review/ReviewByUser.vue
// module id = 1486
// module chunks = 0